import { useEffect } from "react";
import useLeaflet from "../../hooks/useLeaflet";

const L: any = require("leaflet");
L.esri = require("esri-leaflet");

/*
 * This component displays the dybdekort
 */

const Dybdekort = () => {
  const context = useLeaflet();
  useEffect(() => {
    if (!context) return;

    const depthMap = L.tileLayer.wms(
      "https://api.dataforsyningen.dk/ddm?service=WMS",
      {
        layers: "ddm_50m_dybde",
        maxZoom: 18,
      }
    );

    context.map.addLayer(depthMap);

    return () => context.map.removeLayer(depthMap);
  }, [context.map]);

  return null;
};

export default Dybdekort;
